var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VueTables__search-field"},[_c('input',{staticClass:"VueTables__search__input",attrs:{"type":"text","placeholder":"Search...","id":`VueTables__search_${_vm.props.id}`,"autocomplete":"off"},on:{"keyup":e=>_vm.props.search(_vm.props.debounce)(e)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }